import { encode } from '..';
export var expand = function (node) {
    // Title of expand appears as a bold text, followed by empty line
    var result = ["*" + node.attrs.title + "*", ''];
    node.forEach(function (n) {
        result.push(encode(n));
    });
    return result.join('\n');
};
//# sourceMappingURL=expand.js.map